import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/recaudacion/tipos-de-tenencias-vehiculares/';

/**
 * GET Tipos de Tenencias
 * @returns {Promise<Array<object>>}
 */
export const getTiposDeTenencias = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipo de Tenencia
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getTipoDeTenencia = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Tipo de Tenencia
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeTenencia = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de Tenencia
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeTenencia = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Tenencia
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteTipoDeTenencia = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
